/// Um comprovante ainda não enviado. Durante o cadastro o lançamento não existe, e o comprovante
/// precisa de um lançamento para pertencer — então fica aqui até haver a quem pertencer.
export type PendingReceipt = { kind: 'file'; file: File } | { kind: 'link'; url: string };

export function describePending(item: PendingReceipt): string {
  return item.kind === 'file' ? item.file.name : item.url;
}

/// Como a próxima foto se chama.
///
/// Disco e área de transferência trazem nome; a câmera, não. Três linhas escritas "foto.jpg" na
/// lista não dizem qual é qual — e quem tira três fotos de um carnê precisa saber qual remover.
export function nextPhotoName(taken: readonly string[]): string {
  let index = 1;
  let name = 'foto.jpg';
  while (taken.includes(name)) {
    index += 1;
    name = `foto-${String(index)}.jpg`;
  }
  return name;
}

/// O atalho muda de nome conforme o teclado de quem está olhando.
export function pasteShortcut(): string {
  const apple = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/u.test(navigator.platform);
  return apple ? '\u2318V' : 'Ctrl+V';
}

export type ClipboardImages = { ok: true; files: File[] } | { ok: false; detail: string };

/// Pega as imagens da área de transferência sob demanda, para o botão "Colar print".
///
/// No celular não existe Ctrl+V: colar exige segurar o dedo e acertar o menu do sistema, que muda a
/// cada aparelho — e é no celular que se fotografa o comprovante. O atalho continua valendo em quem
/// tem teclado; o botão é um caminho a mais, nunca o único.
export async function readImagesFromClipboard(): Promise<ClipboardImages> {
  try {
    const items = await navigator.clipboard.read();
    const files: File[] = [];
    for (const item of items) {
      const type = item.types.find((candidate) => candidate.startsWith('image/'));
      if (!type) continue;
      const blob = await item.getType(type);
      // O nome não vem junto da área de transferência. Quem decide o tipo é o conteúdo, conferido
      // no servidor, então este nome é só o que a lista mostra até o envio.
      files.push(new File([blob], `colado.${type.slice('image/'.length)}`, { type }));
    }
    if (files.length === 0) {
      return { ok: false, detail: 'Não há imagem copiada na área de transferência.' };
    }
    return { ok: true, files };
  } catch {
    // Permissão negada, navegador sem suporte ou contexto inseguro: o atalho do teclado continua.
    return {
      ok: false,
      detail: `Não foi possível ler a área de transferência. Cole com ${pasteShortcut()}.`,
    };
  }
}
